import { render, staticRenderFns } from "./StuMainTitle.vue?vue&type=template&id=3c0451bf&scoped=true&"
import script from "./StuMainTitle.vue?vue&type=script&lang=js&"
export * from "./StuMainTitle.vue?vue&type=script&lang=js&"
import style0 from "./StuMainTitle.vue?vue&type=style&index=0&id=3c0451bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0451bf",
  null
  
)

export default component.exports